import { render, staticRenderFns } from "./OptionCheck.vue?vue&type=template&id=2200cd36&scoped=true"
import script from "./OptionCheck.vue?vue&type=script&lang=js"
export * from "./OptionCheck.vue?vue&type=script&lang=js"
import style0 from "./OptionCheck.vue?vue&type=style&index=0&id=2200cd36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2200cd36",
  null
  
)

export default component.exports